var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._b({style:(_vm.positions.style)},'svg',_vm.positions.svgProp,false),[_c('path',_vm._b({staticStyle:{"stroke-width":"2"},style:({stroke: 'green'}),attrs:{"fill":"none"}},'path',_vm.positions.pathProp,false))])}
var staticRenderFns = []

export { render, staticRenderFns }